export const formatMoney = (amount: string | null, currency: string | null): string => {
	if (amount === null) return "—";
	const value = Number(amount);
	if (!Number.isFinite(value)) return "—";
	return new Intl.NumberFormat(undefined, {
		style: "currency",
		currency: currency ?? "USD",
	}).format(value);
};

export const formatNumber = (value: number | null): string =>
	value === null ? "—" : new Intl.NumberFormat().format(value);

/** With a time zone, the time is shown there and labelled, as a schedule should be. */
export const formatDate = (value: string | null, timeZone?: string): string => {
	if (!value) return "—";
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return "—";
	if (!timeZone) {
		return new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(
			date,
		);
	}
	return new Intl.DateTimeFormat(undefined, {
		timeZone,
		month: "short",
		day: "numeric",
		year: "numeric",
		hour: "numeric",
		minute: "2-digit",
		timeZoneName: "short",
	}).format(date);
};

const RELATIVE_UNITS: readonly [Intl.RelativeTimeFormatUnit, number][] = [
	["second", 60],
	["minute", 60],
	["hour", 24],
	["day", 7],
	["week", 4.348],
	["month", 12],
	["year", Infinity],
];

export const formatRelative = (value: string | null): string => {
	if (!value) return "—";
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return "—";

	const formatter = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
	let amount = (date.getTime() - Date.now()) / 1000;

	for (const [unit, step] of RELATIVE_UNITS) {
		if (Math.abs(amount) < step) return formatter.format(Math.round(amount), unit);
		amount /= step;
	}

	return formatDate(value);
};

export const titleCase = (value: string | null): string => {
	if (!value) return "—";
	return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};
